// GALLERY SECTION ********************************  
$(window).on("load", function() {                                            



   // globals ***
   var done = true,
       galleryImgWidth, 
       galleryCarPosition = 0;



   // set carousel variables  &  convert to grid layout in mobile *** 
   $(window).on("resize", function() {     

   	  galleryImgWidth = $("#GalleryCarousel").width();

	  $("#GalleryCarouselInner .galleryimg").css({"width": galleryImgWidth });  

	  $("#GalleryCarouselInner").css({"width": galleryImgWidth * 4 }); 

      // reset car
	  $("#GalleryCarouselInner").css({"left":"0px"}); 
	  galleryCarPosition = 0; 

   }).resize();



   // controls *** 
   $("#GallerySection .gallerycontrol").click(function() { 

   	   if (done) { 

   	   	  doneUtil(); 

	   	  // left 
	      if ($(this).hasClass("left") && (galleryCarPosition > 0)) {
	      	 galleryCarPosition--; 
	      	 moveGalleryCarousel(); 
	      }

	      // right
	      if ($(this).hasClass("right") && (galleryCarPosition < 2)) {
	      	 galleryCarPosition++; 
	      	 moveGalleryCarousel();
	      }

       }

   });  
   


   // move gallery ***
   function moveGalleryCarousel() {  
      $("#GalleryCarouselInner").css({"left": ((galleryImgWidth * galleryCarPosition) * -1)  }); 
   }



   // done util *** 
   function doneUtil() {
	  done = false;
      setTimeout(function() { done = true; }, 800);
   }



});

 






// MODAL SECTION ********************************       
$(document).ready(function() {        


   // init *********
   var modal = $("#Modal"),
       num, 
       done = true,
       data = [
          {
            h1: "Before Games",
            p: "Many schools and fields do not have many batting cages. So prior to a game during warmups, make six piles of smushballs (40 in each pile if you purchased a case) and have six players throw to six hitters and the rest of the team can shag balls. Once finished, make the piles again and rotate so six more players now become hitters. Then when finished, rotate again. In literally 15-20 minutes, the entire team has had 40 swings to get warmed and focused."
          },
          {
            h1: "Placing Drill",
            p: "Player throws from his knees five yards away from the batter over a plate. Do not have the players lob the ball, but rather throw it softly waist high. Have batters learn to place the ball by hitting throws that are inside and outside."
          },
          {
            h1: "Speed Drill",
            p: "Player stands 5 to ten yards from the batter and throws overhand and gradually throws harder and harder. Mix up throws with variations including throwing sidearm, changeups and fastballs."
          },
          {
            h1: "Soft Toss",
            p: "Use any fence and have the player kneel and toss a ball whereas the batter can then hit into the fence.Younger players can also hit off of a tee into a fence. The faster and harder the swing, the more power the Smush ball will have and it can stick in the fence or go through. No damage is done to anything. A variation is to have a point system..ie 1 point for hitting the ball, two points for sticking it in the fence and 5 points to hit the ball through the fence."
          },
          {
            h1: "Best of The Best",
            p: "Here you have all the boys compete and the coach throws one at a time over the strike zone and try to get the batter to miss. The object is for the batter to see how many in a row they can hit. Once they swing and miss, a new batter begins. Indoor placement – In a gym, have the batter stand underneath one of the baskets. The person throwing throws from the free throw line.Have targets for the batter to aim at. Points can be used to see who does the best. One point for hitting, two points to hit it past the oppositefree throw line. Five points to hit the opposite wall and five points in hitting specific targets.(chairs, backboard etc)."
          },
          {
            h1: "Eye Focus",
            p: "Mark balls with a round spot the size of a quarter. Give some balls a red spot, some a black spot, some a green. As the ball is thrown to the batter, have him call out the color as he swings and hits."
          },
          {
            h1: "For Catchers",
            p: "You can also use these balls for blocking drills for catchers, indoor or outdoor."
          },
          {
            h1: "For Pitchers",
            p: "Work on proper release positions or loosen arms and shoulders without tiring the arm."
          }
       ]; 
       


   // open modal ********* 
   $("#DrillSection .col").click(function() {

      if (done) {

         done = false;  
         num = $(this).attr("data-num");  
         openModal();
         
      }

   }); 
   


   // close modal *********
   $(".modalsection .close").click(function() {

      if (!done) {

         modal.css({"opacity":"0","transform":"scale(0.9)"});
         setTimeout(function() {
            modal.css({"display":"none"});
            done = true;    
         }, 1000);

      }

   });



   // modal open *********  
   function openModal() {

      modal.css({"display":"block"});
      modal.find("h1").html(data[num - 1].h1);
      modal.find("p").html(data[num - 1].p);

      setTimeout(function() {  
         modal.css({"height": 155 + modal.find(".contentinner").height() });     
         setTimeout(function() {
            modal.css({"opacity":"1","transform":"scale(1)"});   
         }, 50);
      }, 50);

   }

   $(window).on("resize", function() { modal.css({"height": 155 + modal.find(".contentinner").height() }); });  



}); 








// SETUP VIDEO PLAYER ********************************            
$(window).on("load", function() {                                                                                                     

   const player = new Plyr('video', {captions: {active: true}});
   window.player = player;  

});







